import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { Center, Spinner } from '@/components/ui'
import { clearAPICache, useQuerySuspense } from '@/lib/api'
import {
  AuthenticatedUserProvider,
  getAuthenticatedUser,
  getAuthState,
} from '@/lib/auth'

export const Route = createFileRoute('/_authenticated')({
  pendingComponent: () => {
    return (
      <Center h="svh" w="svw">
        <Spinner />
      </Center>
    )
  },
  beforeLoad: async () => {
    const { isAuthenticated, shouldAgreeTerms } = await getAuthState()
    if (!isAuthenticated) {
      clearAPICache()
      throw redirect({
        to: '/login',
        search: {
          redirectTo: window.location.pathname + window.location.search,
        },
      })
    }
    if (shouldAgreeTerms) {
      throw redirect({
        to: '/agreements',
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { data: authenticatedUser } = useQuerySuspense(
    'authenticatedUser',
    getAuthenticatedUser,
    { revalidateIfStale: false },
  )
  return (
    <AuthenticatedUserProvider authenticatedUser={authenticatedUser}>
      <Outlet />
    </AuthenticatedUserProvider>
  )
}
